export default __webpack_public_path__ + "static/media/img-guide-gt-popup-5-int_en@2x.44baa526.png";